import React from "react";
import { Link, useParams } from "react-router-dom";

const OrderConfirmation = () => {
  const {orderId} = useParams();
  return (
    <>
      <style>{`
        /* Full page background */
        .confirmation-page {
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 100vh;
          background: linear-gradient(135deg, #ff9a9e, #fad0c4, #fbc2eb, #a1c4fd);
          background-size: 300% 300%;
          animation: gradientMove 8s ease infinite;
          padding: 20px;
        }

        @keyframes gradientMove {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }

        .confirmation-card {
          background: #fff;
          border-radius: 20px;
          padding: 40px 30px;
          text-align: center;
          max-width: 500px;
          width: 100%;
          box-shadow: 0 10px 30px rgba(0,0,0,0.15);
          animation: fadeIn 1s ease-in-out;
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }

        .checkmark {
          font-size: 70px;
          color: #4caf50;
          margin-bottom: 20px;
          animation: bounce 1s infinite;
        }

        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-8px); }
        }

        .title {
          font-size: 28px;
          font-weight: bold;
          margin-bottom: 15px;
          color: #333;
        }

        .message {
          font-size: 16px;
          color: #555;
          margin-bottom: 25px;
          line-height: 1.6;
        }

        .order-details {
          background: #f9f9f9;
          border-radius: 12px;
          padding: 20px;
          text-align: left;
        }

        .order-details h3 {
          font-size: 18px;
          margin-bottom: 12px;
          color: #444;
        }

        .order-details ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .order-details li {
          font-size: 15px;
          margin: 6px 0;
          color: #555;
        }

        .order-details span {
          font-weight: bold;
          color: #222;
        }
      `}</style>

      <div className="confirmation-page">
        <div className="confirmation-card">
          <div className="checkmark">&#10004;</div>
          <h2 className="title">🎉 Congratulations!</h2>
          <p className="message">
            Your order has been successfully processed.  
            Sit back and relax, we’ll notify you once it’s on the way. 🚚
          </p>

          <div className="order-details">
            <h3>Order Summary</h3>
            <ul>
              <li>✔ Order ID: <span>{orderId}</span></li>
              <li>✔ Estimated Delivery: <span>3–5 Days</span></li>
            </ul>
          </div>
          <Link to='/'>
            <button type="button" className="btn btn-primary mt-5 p-3">Back to Store</button>
            {/* <button type="button" className="btn btn-primary mt-5 p-3">View </button> */}
          </Link>
        </div>
      </div>
    </>
  );
};

export default OrderConfirmation;
